import { render, staticRenderFns } from "./analysisIndvidual.vue?vue&type=template&id=23b2fdd7&scoped=true"
import script from "./analysisIndvidual.vue?vue&type=script&lang=js"
export * from "./analysisIndvidual.vue?vue&type=script&lang=js"
import style0 from "./analysisIndvidual.vue?vue&type=style&index=0&id=23b2fdd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b2fdd7",
  null
  
)

export default component.exports